<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row" v-if="userData.permissions['view_financial_years']==1">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-option size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Financial Year</b-button>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(role)="data">
                  {{ data.item.role.name }}
                </template>
                  <template #cell(active)="data">
                  <span v-if="data.item.active==1">
                    <b-button type="button" class="btn-sm btn" variant="info" v-b-modal.password> <i class="mdi mdi-check"></i> Active </b-button>
                  </span>
                  <span v-else>
                    <b-button @click="makedefault(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="secondary" v-b-modal.password> <i class="mdi mdi-lock"></i> Set as Active</b-button>
                    </span>
                  </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button @click="edit(data.item.id,data.item.name,data.item.start,data.item.end )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Financial Years</span></center>
          </div>
        </div>
      </div>
    </div>
      <b-modal id="new-option" centered title="New Financial Year" title-class="font-18" hide-footer>
          <form @submit.prevent="addOption">
              <div class="form-group mb-2">
              <label>Name</label>
              <input v-model="name" type="text" class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Start</label>
              <input v-model="start" type="date" class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>End</label>
              <input v-model="end" type="date" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-option')" >Cancel</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="edit-option" centered title="Edit Financial Year" title-class="font-14" hide-footer>
          <form @submit.prevent="editOption">
              <div class="form-group mb-2">
              <input v-model="id" type="hidden">
              <label>Name</label>
              <input v-model="name" type="text" class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Start</label>
              <input v-model="start" type="date" class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>End</label>
              <input v-model="end" type="date" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-option')" >Cancel</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="change-option" centered title="Set as Active Year" title-class="font-18" hide-footer>
          <form @submit.prevent="makeDefualtOption">
            <input v-model="id" type="hidden">
            Are you sure you want to make <b>{{ name }}</b> the active Financial Year
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('change-option')" >Cancel</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="delete-option" centered title="Delete Financial Year" title-class="font-12" hide-footer>
          <form @submit.prevent="removeOption">
              <input v-model="id" type="hidden">
                Are you sure you want to delete the Financial Year : <b>{{ name }}</b> ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-option')" >Cancel</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
              </div>
          </form>
      </b-modal>
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  // import Multiselect from "vue-multiselect";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { financialyearMethods, financialyearComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Financial Years",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Financial Years",
        items: [ {text: "Dashboard",to: "/",}, {text: "Financial Years",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'name', label: 'Name', visible: true },
            { key: 'start', label: 'Start', visible: true },
            { key: 'end', label: 'End', visible: true },
            { key: 'active', label: 'Active', visible: true },
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'', name:'', start:'', end:'',
      };
    },
    computed: {
      ...financialyearComputed,
      List() { return this.financialyears.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.financialyears.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.financialyears.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchFinancialYears();
      this.TotalRows = this.financialyears.length;
      this.isBusy=false;
    },
    methods: {
      ...financialyearMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      edit(id,name,start,end){
        this.id=id;
        this.name=name;
        this.start=start;
        this.end=end;
        this.$bvModal.show('edit-option')
      },
      makedefault(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('change-option')
      },
      remove(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('delete-option')
      },
      async addOption() { 
        let formData = new FormData();
        formData.append("name", this.name);
        formData.append("start", this.start);
        formData.append("end", this.end);
        let url = "/addfinancialyear";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchFinancialYears();
            this.$bvModal.hide('new-option');
            this.name="";
            this.start="";
            this.end="";
        }
        });
      },
      async makeDefualtOption(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/activefinancialyear";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          localStorage.setItem("financialyear", JSON.stringify(response.data.year));
          this.fetchFinancialYears();
          this.$bvModal.hide('change-option');
        }
      });
      },
      async editOption(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("start", this.start);
      formData.append("end", this.end);
      let url = "/updatefinancialyear";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchFinancialYears();
          this.$bvModal.hide('edit-option');
          this.name="";
          this.start="";
          this.end="";
        }
      });
      },
      async removeOption() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removefinancialyear";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchFinancialYears();
          this.$bvModal.hide('delete-option');
        }
      });
      },
    },
  };
  </script>